import axios from 'axios';

const api = axios.create({
baseURL:"https://admin.houseofdhanushdhari.com/api/" 
 // baseURL:"https://rndsan.com/"
});

export default api;